module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenterb"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm06"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("“… On the trees no leaf is seen"), _c('br'), _vm._v("Nor are the meadows growing green,"), _c('br'), _vm._v("Birds build no nest, no song is sung,"), _c('br'), _vm._v("And hapless beasts shall bear no young,"), _c('br'), _vm._v("So is it while the sinful king"), _c('br'), _vm._v("Shall evil on his people bring."), _c('br'), _vm._v("For Jesus Christ does punish well"), _c('br'), _vm._v("The land wherein the wicked dwell.”")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "textleft"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SONE DE NANSAI")]), _vm._v(", 11.4848-56")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-882e3d18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06.vue
// module id = 69
// module chunks = 0